import React from "react";
import { WhatsAppIcon } from "./Navbar";
import { api } from "../api";

const TelegramIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const FloatingChannels = ({ site }) => {
  if (!site) return null;
  const whatsappUrl = site.whatsappUrl;
  const telegramUrl = site.telegramUrl;

  const track = () => {
    if (site.id) api.recordClick(site.id).catch(() => {});
  };

  return (
    <>
      {/* Telegram - left, mirrored */}
      {telegramUrl && (
        <a
          href={telegramUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={track}
          aria-label="Chat on Telegram"
          className="fab fab-left group fixed left-4 sm:left-6 bottom-24 sm:bottom-8 z-50 inline-flex items-center gap-2 bg-[#229ED9] hover:bg-[#1c8dc2] text-white font-semibold rounded-full pl-3 pr-4 py-3 shadow-lg transition-all"
        >
          <span className="fab-ping-blue inline-flex items-center justify-center rounded-full">
            <TelegramIcon className="w-6 h-6" />
          </span>
          <span className="hidden sm:inline text-sm whitespace-nowrap max-w-0 overflow-hidden group-hover:max-w-[120px] transition-all duration-300">
            Telegram
          </span>
        </a>
      )}

      {/* WhatsApp - right, mirrored */}
      {whatsappUrl && (
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={track}
          aria-label="Chat on WhatsApp"
          className="fab fab-right group fixed right-4 sm:right-6 bottom-24 sm:bottom-8 z-50 inline-flex flex-row-reverse items-center gap-2 bg-[#25D366] hover:bg-[#1fb757] text-white font-semibold rounded-full pr-3 pl-4 py-3 shadow-lg transition-all"
        >
          <span className="fab-ping-green inline-flex items-center justify-center rounded-full">
            <WhatsAppIcon className="w-6 h-6" />
          </span>
          <span className="hidden sm:inline text-sm whitespace-nowrap max-w-0 overflow-hidden group-hover:max-w-[120px] transition-all duration-300">
            WhatsApp
          </span>
        </a>
      )}
    </>
  );
};

export { TelegramIcon };
export default FloatingChannels;
